var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TabSelection from './TabSelection';

export var TabSelectionContext = React.createContext({
  selection: {}
});

var TabProvider = function (_Component) {
  _inherits(TabProvider, _Component);

  function TabProvider(props) {
    _classCallCheck(this, TabProvider);

    var _this = _possibleConstructorReturn(this, (TabProvider.__proto__ || Object.getPrototypeOf(TabProvider)).call(this, props));

    _this.selection = new TabSelection({
      defaultTab: props.defaultTab,
      vertical: props.vertical,
      collapsible: props.collapsible,
      onChange: props.onChange
    });
    return _this;
  }

  _createClass(TabProvider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.defaultTab !== nextProps.defaultTab && !this.selection.isSelected(nextProps.defaultTab)) {
        this.selection.select(nextProps.defaultTab);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return React.createElement(
        TabSelectionContext.Provider,
        { value: this.selection },
        children
      );
    }
  }]);

  return TabProvider;
}(Component);

TabProvider.defaultProps = {
  defaultTab: undefined,
  onChange: undefined,
  vertical: false,
  collapsible: false
};
TabProvider.propTypes = {
  children: PropTypes.node.isRequired,
  defaultTab: PropTypes.string,
  vertical: PropTypes.bool,
  collapsible: PropTypes.bool,
  onChange: PropTypes.func
};


export default TabProvider;